// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__18_yb","info":"Note_info__yFPI4","note":"Note_note__lmird","actions":"Note_actions__nzJab"};